import { Injectable } from '@angular/core';
import {
  CheckRegisterRequest,
  CheckRegisterResponse,
  CheckTokenResponse,
  ConfirmRegisterUserPayload,
  ConfirmRegisterUserResponse,
  LineAuthLookupResponse,
  LineAuthSessionRequest,
  LineAuthSessionResponse,
  RegisterUserPayload,
  RegisterUserResponse,
} from '../../../models/user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../config.service';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiLineLiffService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  lookupAuth(body: LineAuthSessionRequest): Observable<LineAuthLookupResponse> {
    return this.http.post<LineAuthLookupResponse>(
      `${this.tokenUrl}/LineAuth/lookup`,
      body,
    );
  }

  issueMemberToken(
    body: LineAuthSessionRequest,
  ): Observable<LineAuthSessionResponse> {
    return this.http.post<LineAuthSessionResponse>(
      `${this.tokenUrl}/LineAuth/token`,
      body,
    );
  }

  establishSession(
    body: LineAuthSessionRequest,
  ): Observable<LineAuthSessionResponse> {
    return this.http.post<LineAuthSessionResponse>(
      `${this.tokenUrl}/LineAuth/session`,
      body,
    );
  }

  /** Request OTP — auth via HttpOnly LINE session cookie (reg_pending). */
  reqeustOTP(
    data: RegisterUserPayload,
    _token?: string,
  ): Observable<RegisterUserResponse> {
    const formData = new FormData();
    formData.append('Uid', data.uid || '');
    formData.append('Full_name', data.full_name || '');
    formData.append('Phone', data.phone || '');
    formData.append('Email', data.email || '');
    formData.append('Referral_code', data.referral_code || '');
    formData.append('InviteCode', data.inviteCode || '');
    formData.append('Language', data.language || '');
    formData.append('PictureUrl', data.pictureUrl || '')

    // console.log("Data : ", formData)
    return this.http.post<RegisterUserResponse>(
      this.tokenUrl + '/Register/register',
      formData,
    );
  }

  verifyToken(): Observable<CheckTokenResponse> {
    console.log("เข้าหน้าverifyToken แล้ว !!")
    return this.http.get<CheckTokenResponse>(
      this.tokenUrl + `/Register/verify-token`,
    );
  }

  /** Confirm OTP — auth via HttpOnly LINE session cookie. */
  confirmOTP(
    data: ConfirmRegisterUserPayload,
    _token?: string,
  ): Observable<ConfirmRegisterUserResponse> {
    const formData = new FormData();
    formData.append('Uid', data.uid || '');
    formData.append('Phone_number', data.phone_number || '');
    formData.append('Ref_no', data.ref_no || '');
    formData.append('Pin_code', data.pin_code || '');

    return this.http.post<ConfirmRegisterUserResponse>(
      this.tokenUrl + '/Register/confirm_register',
      formData,
    );
  }

  /** @deprecated Use establishSession */
  checkRegister(req: CheckRegisterRequest): Observable<CheckRegisterResponse> {
    const formData = new FormData();
    formData.append('uid', req.uid);

    return this.http.post<CheckRegisterResponse>(
      `${this.tokenUrl}/Register/check-registration`,
      formData,
    );
  }
}
